import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

interface ReportDiscrepancyParams {
  notificationId: string;
  monitoringId?: string;
  productName: string;
  productSku?: string;
  productBc?: string;
  reportedAmount: number;
  expectedAmount?: number;
  notes?: string;
  reportedBy?: string;
  reportedByName?: string;
}

export const useReportStockDiscrepancy = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: ReportDiscrepancyParams) => {
      const { data, error } = await supabase
        .from("stock_discrepancy_reports")
        .insert({
          notification_id: params.notificationId,
          monitoring_id: params.monitoringId,
          product_name: params.productName,
          product_sku: params.productSku,
          product_bc: params.productBc,
          reported_amount: params.reportedAmount,
          expected_amount: params.expectedAmount,
          notes: params.notes,
          reported_by: params.reportedBy,
          reported_by_name: params.reportedByName,
        })
        .select()
        .single();

      if (error) throw error;
      return data;
    },
    onSuccess: () => {
      toast.success("Voorraadverschil gemeld");
      queryClient.invalidateQueries({ queryKey: ["stock-alert-details"] });
      queryClient.invalidateQueries({ queryKey: ["stock-alerts"] });
    },
    onError: (error) => {
      console.error("Error reporting stock discrepancy:", error);
      toast.error("Fout bij melden voorraadverschil");
    },
  });
};
